<template>
    <div class="page-template-stats">
        <document-statistics v-if="route.params && route.params.id" :document-template-id="route.params.id"></document-statistics>
    </div>
</template>

<script setup>
    import { useRoute } from 'vue-router'
    const route = useRoute();
</script>